import { useState, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { SwiperContainer, type ItemType } from '../components/swiper-container';
import { ArticleContainer } from '../components/article-container';
import { Page1Image, Page2Image, Page3Image, Page4Image } from './components';
import { tutorialParlayStyle } from './tutorial-parlay.style';
import { ModalContainer } from '../components/modal-container';

type TutorialCashoutProps = {
	isOpen: boolean;
	closeModal: () => void;
}

export const TutorialParlay = ({
	isOpen,
	closeModal,
}: TutorialCashoutProps) => {
	const [sliderIndex, setSliderIndex] = useState(0);
	const t = useTranslations('General');

	const parlayHelpPage: Array<ItemType> = [
		{
			title: t('lbl_PIntro_WhatsParlay'),
			content: t('lbl_HowToUseBet06'),
			slide: <SlidePage1 />
		},
		{
			title: t('lbl_HowToUseBet09'),
			content: <Content2 />,
			slide: <SlidePage2 />
		},
		{
			title: t('lbl_MarsParlayHelp4'),
			content: t('lbl_HowToUseBet10'),
			slide: <SlidePage3 />
		},
		{
			title: t('lbl_MarsParlayHelp5'),
			content: t('lbl_MarsParlayHelp6'),
			slide: <SlidePage4 />
		},
	]

	useEffect(() => {
		setSliderIndex(0)
	}, [isOpen])

	return (
		<ModalContainer
			isOpen={isOpen}
			closeModal={closeModal}
			title={t('lbl_MarsParlayHelp1')}
		>
			<SwiperContainer
				currentSlider={sliderIndex}
				setCurrentSlider={setSliderIndex}
				data={parlayHelpPage}
			/>

			<ArticleContainer title={parlayHelpPage[sliderIndex].title}>
				<div className={tutorialParlayStyle.text}>{parlayHelpPage[sliderIndex].content}</div>
			</ArticleContainer>
		</ModalContainer>
	);
}
const SlidePage1 = () => {
	const t = useTranslations('General');
	return (
		<>
			<Page1Image />
			<div className={tutorialParlayStyle.page1Label1}>
				<span>{t('lbl_mixparlay')}</span>
				<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
					<path d="M7.02657 2.9732C6.8403 2.78693 6.53939 2.78693 6.35312 2.9732L4.49969 4.82592L2.64625 2.9732C2.60204 2.92898 2.54954 2.89391 2.49176 2.86997C2.43399 2.84604 2.37206 2.83372 2.30953 2.83372C2.24699 2.83372 2.18507 2.84604 2.12729 2.86997C2.06952 2.89391 2.01702 2.92898 1.9728 2.9732C1.92858 3.01742 1.8935 3.06992 1.86957 3.12769C1.84564 3.18547 1.83332 3.24739 1.83332 3.30993C1.83332 3.37247 1.84564 3.43439 1.86957 3.49216C1.8935 3.54994 1.92858 3.60244 1.9728 3.64666L4.16511 5.83897C4.35138 6.02524 4.65229 6.02524 4.83856 5.83897L7.03087 3.64666C7.11868 3.5563 7.16745 3.43504 7.16665 3.30905C7.16584 3.18306 7.11553 3.06243 7.02657 2.9732Z" fill="white" />
				</svg>
			</div>
			<div className={tutorialParlayStyle.page1Label2}>
				<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
					<path d="M6 2.5C8.20909 2.5 10 4.29091 10 6.5C10 8.70909 8.20909 10.5 6 10.5C3.79091 10.5 2 8.70909 2 6.5C2 4.29091 3.79091 2.5 6 2.5ZM6 3.04545C4.09218 3.04545 2.54545 4.59218 2.54545 6.5C2.54545 8.40782 4.09218 9.95455 6 9.95455C7.90782 9.95455 9.45455 8.40782 9.45455 6.5C9.45455 4.59218 7.90782 3.04545 6 3.04545ZM6.09091 8.21364C6.26691 8.21436 6.40909 8.35945 6.40909 8.53909C6.40909 8.71782 6.26691 8.86364 6.09091 8.86364C5.91564 8.86364 5.77273 8.71855 5.77273 8.53909C5.77273 8.35945 5.91491 8.21364 6.09091 8.21364ZM6.09091 4.31818C6.84418 4.31818 7.45455 4.94764 7.45455 5.72418C7.45455 6.142 7.20255 6.50436 6.73945 6.81236C6.51436 6.96236 6.37836 7.21964 6.37836 7.49618V7.54618C6.37745 7.70964 6.24927 7.84182 6.09182 7.84255C5.93327 7.84255 5.80527 7.70964 5.80527 7.54618V7.49618C5.80527 7.01873 6.04073 6.574 6.42945 6.31527C6.74455 6.10545 6.88145 5.908 6.88145 5.72436C6.88145 5.27436 6.52818 4.91 6.09182 4.91C5.65545 4.91 5.30218 5.27436 5.30218 5.72418C5.30218 5.88855 5.17309 6.02055 5.01473 6.02055C4.85545 6.02055 4.72727 5.88764 4.72727 5.72418C4.72727 4.94764 5.33764 4.31818 6.09091 4.31818Z" fill="#FFB06B" />
				</svg>
				<span>{t('lbl_mixparlay')}</span>
			</div>
			<div className={tutorialParlayStyle.page1Label3}>
				{t('lbl_trebles')} @64.3025
			</div>
			<div className={tutorialParlayStyle.page1Label4}>
				<strong>{t('lbl_trebles')}</strong><br />
				{t('lbl_odds')}: 3.40x4.45x4.25=<strong>64.3025</strong><br />
				{t('lbl_stake')}:<strong>100</strong><br />
				{t('lbl_payout')}: <span className={tutorialParlayStyle.page1Label4_payout}>6,430.25</span>
			</div>
			<div className={tutorialParlayStyle.page1Label5}>{t('lbl_mixparlay')}</div>
		</>
	)
}

const SlidePage2 = () => {
	const t = useTranslations('General');
	return (
		<>
			<Page2Image />
			<div className={tutorialParlayStyle.page2Label1}>
				<span>{t('Betsilp')}</span>
				<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="none" viewBox="0 0 9 9">
					<path fill="#F33" d="M.5 4.25a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z" />
					<path fill="#fff" d="M2.944 6.25v-.51c.136-.092.288-.204.456-.336.172-.136.342-.286.51-.45.172-.164.328-.334.468-.51.144-.18.26-.356.348-.528.088-.176.132-.344.132-.504 0-.12-.026-.23-.078-.33a.557.557 0 0 0-.264-.24 1.138 1.138 0 0 0-.492-.09c-.22 0-.416.042-.588.126-.172.08-.324.168-.456.264v-.624c.144-.088.314-.166.51-.234s.422-.102.678-.102c.316 0 .574.054.774.162.2.104.346.246.438.426.096.176.144.372.144.588 0 .184-.042.368-.126.552a2.612 2.612 0 0 1-.336.54 5.334 5.334 0 0 1-.45.51c-.164.16-.33.31-.498.45-.164.136-.316.258-.456.366l-.156-.15H5.59v.624H2.944Z" />
				</svg>
			</div>
			<div className={tutorialParlayStyle.page2Label2}>
				<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" fill="none" viewBox="0 0 13 12">
					<path fill="#FF7E1C" d="M9.463 10H2.28c-.68 0-.53-.5-.482-.6 0 0 .597-1.324.744-1.587a.41.41 0 0 1 .162-.174.39.39 0 0 1 .228-.051h7.972c.375 0 .238.274.238.274L10.38 9.45a1.09 1.09 0 0 1-.388.401 1.04 1.04 0 0 1-.529.149Zm1.44-3.069h-7.97a.303.303 0 0 1-.163-.054.32.32 0 0 1-.11-.135l-.757-1.518c-.048-.089-.045-.305.13-.307h8.039c.24.014.251.025.35.21l.748 1.48s.2.324-.266.324Zm-.663-2.736H2.172c-.352 0-.232-.309-.232-.309L2.714 2.5a1.19 1.19 0 0 1 .424-.371c.168-.087.353-.131.54-.129h7.184c.48 0 .407.468.337.65-.07.182-.601 1.309-.601 1.309a.42.42 0 0 1-.147.17.4.4 0 0 1-.211.066Z" />
				</svg>
				<span>串關投注未成立，請組合更多投注。</span>
			</div>
			<div className={tutorialParlayStyle.page2Label3}>Team A</div>
			<div className={tutorialParlayStyle.page2Label4}>Team B</div>
			{/* for desktop */}
			<div className={tutorialParlayStyle.page2Label5}>{t('lbl_bet')}</div>
		</>
	)
}

const Content2 = () => {
	const t = useTranslations('General');
	return (
		<>
			{t('lbl_MarsParlayHelp3')}
			<ul className={tutorialParlayStyle.ul}>
				<li>{t('lbl_HowToUseBet10')}</li>
				<li>{t('lbl_HowToUseBet11')}</li>
				<li>{t('lbl_HowToUseBet12')}</li>
			</ul>
		</>
	)
}

const SlidePage3 = () => {
	const t = useTranslations('General');
	return (
		<>
			<Page3Image />
			<div className={tutorialParlayStyle.page3Label1}>
				<span>{t('Betsilp')}</span>
				<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="none" viewBox="0 0 9 9">
					<path fill="#F33" d="M.5 4.25a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z" />
					<path fill="#fff" d="M2.944 6.25v-.51c.136-.092.288-.204.456-.336.172-.136.342-.286.51-.45.172-.164.328-.334.468-.51.144-.18.26-.356.348-.528.088-.176.132-.344.132-.504 0-.12-.026-.23-.078-.33a.557.557 0 0 0-.264-.24 1.138 1.138 0 0 0-.492-.09c-.22 0-.416.042-.588.126-.172.08-.324.168-.456.264v-.624c.144-.088.314-.166.51-.234s.422-.102.678-.102c.316 0 .574.054.774.162.2.104.346.246.438.426.096.176.144.372.144.588 0 .184-.042.368-.126.552a2.612 2.612 0 0 1-.336.54 5.334 5.334 0 0 1-.45.51c-.164.16-.33.31-.498.45-.164.136-.316.258-.456.366l-.156-.15H5.59v.624H2.944Z" />
				</svg>
			</div>
			<div className={tutorialParlayStyle.page3Label2}>Team A</div>
			<div className={tutorialParlayStyle.page3Label3}>Team B</div>
			<div className={tutorialParlayStyle.page3Label4}>Team C</div>
			<div className={tutorialParlayStyle.page3Label5}>
				<span>{t('lbl_ShowSelections')}</span>
				<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
					<path d="M1.90759 6.50592C2.11715 6.71548 2.45567 6.71548 2.66523 6.50592L4.75034 4.42161L6.83545 6.50592C6.8852 6.55566 6.94426 6.59513 7.00926 6.62205C7.07425 6.64897 7.14392 6.66283 7.21427 6.66283C7.28462 6.66283 7.35429 6.64897 7.41928 6.62205C7.48428 6.59513 7.54334 6.55566 7.59309 6.50592C7.64284 6.45617 7.6823 6.39711 7.70922 6.33211C7.73614 6.26712 7.75 6.19745 7.75 6.1271C7.75 6.05675 7.73614 5.98708 7.70922 5.92208C7.6823 5.85709 7.64284 5.79803 7.59309 5.74828L5.12674 3.28193C4.91718 3.07237 4.57866 3.07237 4.3691 3.28193L1.90276 5.74828C1.80397 5.84993 1.74911 5.98635 1.75001 6.12809C1.75092 6.26983 1.80751 6.40554 1.90759 6.50592Z" fill="#1E6EAB" />
				</svg>
			</div>
			<div className={tutorialParlayStyle.page3Label6}>{t('lbl_trebles')}</div>
			<div className={tutorialParlayStyle.page3Label7}>{t('lbl_bet')}</div>
		</>
	)
}

const SlidePage4 = () => {
	const t = useTranslations('General');
	return (
		<>
			<Page4Image />
			<div className={tutorialParlayStyle.page4Label1}>
				<span>{t('Betsilp')}</span>
				<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="none" viewBox="0 0 9 9">
					<path fill="#F33" d="M.5 4.25a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z" />
					<path fill="#fff" d="M2.944 6.25v-.51c.136-.092.288-.204.456-.336.172-.136.342-.286.51-.45.172-.164.328-.334.468-.51.144-.18.26-.356.348-.528.088-.176.132-.344.132-.504 0-.12-.026-.23-.078-.33a.557.557 0 0 0-.264-.24 1.138 1.138 0 0 0-.492-.09c-.22 0-.416.042-.588.126-.172.08-.324.168-.456.264v-.624c.144-.088.314-.166.51-.234s.422-.102.678-.102c.316 0 .574.054.774.162.2.104.346.246.438.426.096.176.144.372.144.588 0 .184-.042.368-.126.552a2.612 2.612 0 0 1-.336.54 5.334 5.334 0 0 1-.45.51c-.164.16-.33.31-.498.45-.164.136-.316.258-.456.366l-.156-.15H5.59v.624H2.944Z" />
				</svg>
			</div>
			<div className={tutorialParlayStyle.page4Label2}>Team A</div>
			<div className={tutorialParlayStyle.page4Label3}>
				<span>{t('lbl_HideSelections')}</span>
				<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
					<path d="M5.87393 2.82593C5.70628 2.65828 5.43546 2.65828 5.26782 2.82593L3.59973 4.49337L1.93164 2.82593C1.89184 2.78613 1.84459 2.75456 1.7926 2.73303C1.7406 2.71149 1.68487 2.7004 1.62858 2.7004C1.5723 2.7004 1.51657 2.71149 1.46457 2.73303C1.41257 2.75456 1.36533 2.78613 1.32553 2.82593C1.28573 2.86573 1.25416 2.91298 1.23262 2.96497C1.21109 3.01697 1.2 3.0727 1.2 3.12899C1.2 3.18527 1.21109 3.241 1.23262 3.293C1.25416 3.345 1.28573 3.39224 1.32553 3.43204L3.29861 5.40512C3.46625 5.57277 3.73707 5.57277 3.90472 5.40512L5.87779 3.43204C5.95683 3.35072 6.00071 3.24159 5.99999 3.12819C5.99927 3.0148 5.95399 2.90623 5.87393 2.82593Z" fill="#1E6EAB" />
				</svg>
			</div>
			<div className={tutorialParlayStyle.page4Label4}>{t('lbl_trebles')}</div>
			<div className={tutorialParlayStyle.page4Label5}>{t('lbl_Trixie')} (4 {t('lbl_bets')})</div>
			<div className={tutorialParlayStyle.page4Label6}>{t('lbl_bet')}</div>
			<div className={tutorialParlayStyle.page4Label7}>{t('lbl_TotalBets')}: <strong>1</strong> {t('lbl_payout')}: <strong>6,430.25</strong></div>
			<div className={tutorialParlayStyle.page4Label8}>4x USD $10 {t('lbl_Treble')}</div>
			<div className={tutorialParlayStyle.page4Label9}>Team A</div>
			<div className={tutorialParlayStyle.page4Label10}>Team B</div>
			<div className={tutorialParlayStyle.page4Label11}>Team C</div>
			<div className={tutorialParlayStyle.page4Label12}>{t('lbl_stake')}</div>
			<div className={tutorialParlayStyle.page4Label13}>{t('lbl_payout')}</div>
		</>
	)
}